<div class="ai-button" (click)="onClick()">
  <ng-container *ngIf="config.buttonSource; else defaultButton">
    <img [src]="config.buttonSource" alt="AI Assistant" />
  </ng-container>
  <ng-template #defaultButton>
    <div class="default-icon">💬</div>
  </ng-template>

  <div class="tooltip">{{ config.tooltip }}</div>
</div>
